import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../../infra/analytics';

const useAssessmentPortalStepPageView = ({
  currentStepIndex,
  stepPaths,
  basePath,
  stepLabel,
}: {
  currentStepIndex: number;
  stepPaths: Record<number, string>;
  basePath: string;
  stepLabel: string;
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const expectedPath = stepPaths[currentStepIndex] ?? basePath;
    if (pathname !== expectedPath) return;
    analytics.logPathPageView(pathname, stepLabel);
  }, [basePath, currentStepIndex, pathname, stepLabel, stepPaths]);
};

export default useAssessmentPortalStepPageView;
